import { render } from "./CardGroup.vue?vue&type=template&id=5bb35695&scoped=true"
import script from "./CardGroup.vue?vue&type=script&lang=js"
export * from "./CardGroup.vue?vue&type=script&lang=js"

import "./CardGroup.vue?vue&type=style&index=0&id=5bb35695&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb35695"]])

export default __exports__